import React from 'react'
import { connect } from "react-redux";
import { SetDepositPayments_CTC } from '$Deposits/store/actions/DepositPost'
import { CHANNEL_Submit, CTC_Submit } from '$Deposits/store/actions/DepositEvent'
import { GetParamsData } from '$Deposits/lib/LibCommonData'



class CTC extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modalVisible: false,
        };
    }

    componentDidMount() {

    }
    componentDidUpdate(prevProps, prevState){
        const { webPiwikUrl } = GetParamsData()
        const {modalVisible} = this.state;
        const {DepositBankActive, DepositNextStep, MethodCodeActive} = this.props;
        if(prevState.modalVisible!==modalVisible){
            if(modalVisible){
                if(MethodCodeActive==="CHANNEL"){
                    webPiwikUrl(`deposit_ctc_${DepositBankActive.code}_popup`,`CTC ${DepositBankActive.code} Popup`)
                }else if(MethodCodeActive==="INVOICE"){
                    webPiwikUrl(`deposit_invoice_popup`,`CTC Deposit Invoice Flow Popup`)
                }
            }else{
                if(!DepositNextStep){
                    webPiwikUrl(`deposit_ctc`,`CTC Deposit Page`)
                }
            }
        }
    }
    componentWillUnmount() {

    }

    render() {

        const {
            SetDepositPayments_CTC,
            DepositNextStep,
            DepositSuccessPage,
            MethodCodeActive,
            TipsView,
            AvailableMethods,
            MoneyInput,
            BankSelect,
            SubmitBtn,
            NextStep,
            CHANNEL_NextStep,
            SuccessPage,
            Modal,
            DepositBankActive,
        } = this.props
        const { code } = DepositBankActive || {}
        const { webPiwikEvent, appPiwikEvent, device } = GetParamsData()

        return (
            <>
                <Modal
                    modalVisible={this.state.modalVisible}
                    code={code}
                    MethodCodeActive={MethodCodeActive}
                    onChange={() => {
                        //https://arcadie.atlassian.net/browse/FOW-1666: 交換順序,RN Modal會蓋住antd Toast.loading
                        this.setState({ modalVisible: false },()=>{
                            SetDepositPayments_CTC()
                        })
                        // SetDepositPayments_CTC().then(res=>{
                        //     this.setState({ modalVisible: false })
                        // })
                    }}
                    onCancel={() => { this.setState({modalVisible: false}) }}
                />
                {
                    (!DepositNextStep || MethodCodeActive != 'CHANNEL') && !DepositSuccessPage &&
                    <>
                        <TipsView msg={'หมายเหตุ: การเลือกฝากในสกุลเงินดิจิตอล บางแพลตฟอร์มอาจ\nเรียกเก็บค่าธรรมเนียมในการดำเนินการ'} />
                        <AvailableMethods />
                        <MoneyInput />
                        <BankSelect />
                        <SubmitBtn
                            submitBtn={CTC_Submit}
                            onPress={() => {
                                const initCapMethodCodeActive = MethodCodeActive.slice(0,1)+MethodCodeActive.slice(1).toLowerCase();
                                if(device === 'APP'){
                                    appPiwikEvent({
                                        category: 'Deposit',
                                        action: 'Submit Deposit Crypto Channel',
                                        name: `Deposit_${initCapMethodCodeActive}flow_${MethodCodeActive === "CHANNEL" ? DepositBankActive.code+"_" :""}C_Next`,
                                        path: `deposit_crypto`,
                                        title: `Crypto Deposit Page`
                                    })
                                }
                                webPiwikEvent(`Deposit`, `Submit Deposit Crypto ${initCapMethodCodeActive}`, `Deposit_${initCapMethodCodeActive}flow_${MethodCodeActive === "CHANNEL" ? DepositBankActive.code+"_" :""}C_Next`)
                                this.setState({ modalVisible: MethodCodeActive === "CHANNEL" })
                                if(MethodCodeActive === "INVOICE") SetDepositPayments_CTC()
                             }}
                            submitBtnItem={'ถัดไป'}
                        />
                    </>
                }
                {
                    MethodCodeActive != 'CHANNEL' && DepositNextStep &&
                    <NextStep />
                }
                {
                    MethodCodeActive == 'CHANNEL' && DepositNextStep &&
                    <CHANNEL_NextStep />
                }

                {
                    DepositSuccessPage &&
                    <SuccessPage />
                }

            </>
        );
    }
}

const mapStateToProps = state => ({
    MethodCodeActive: state.MethodCodeActive,
    DepositNextStep: state.DepositNextStep,
    DepositSuccessPage: state.DepositSuccessPage,
    DepositBankActive: state.DepositBankActive,
});
const mapDispatchToProps = {
    SetDepositPayments_CTC: (data = {}) => SetDepositPayments_CTC(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(CTC);


